import { useState, useEffect, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { IoIosArrowBack } from "react-icons/io";
import { DatePicker } from "@mui/x-date-pickers";
import CloseIcon from '@mui/icons-material/Close';
import "../../App.css";
import { Autocomplete, FormControl, FormControlLabel, MenuItem, Radio, RadioGroup, Select, Modal, TextField, createFilterOptions,} from "@mui/material";
import { Box, Checkbox, IconButton, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import {
  useFetchGetAllProjectBasedUserNameListQuery,
  useFetchGetallUserListQuery,
  useFetchUserAccessedProjectsQuery,
  useFetchuserbasedIssuesQuery,
  useFetchuserbasedTasksQuery,
} from "../../slice/logdetailSlice";
import { createEntity, postdatas } from "../../apis/apiService";
import { toast } from "react-toastify";
import { BtnLoader } from "./Loader";
import { format,  } from "date-fns";
import { customFilterOptions, formatTaskOptions } from "./CommonAddLogHour";
import taskImage from "../../assets/images/Header/Task.png";
import milestoneImage from "../../assets/images/Header/MilestoneIcon.png";
import issueImage from "../../assets/images/Header/issue image.png";
import dayjs from "dayjs";
import { openInNewTab } from "../../utils/openInNewTab";


const filter = createFilterOptions();
export const formatIssueOptions = (data) => {
  const options = [];

  // Milestone issues
  data?.milestones?.forEach((milestone) => {
    options.push({
      title: milestone.name,
      isHeader: true,
      type: "milestone",
    });

    milestone.issues?.forEach((issue) => {
      const status = (issue.current_status_name || issue.status_name || "").toUpperCase();
      if (!status.includes("CLOSED")) {
        options.push({
          ...issue,
          title: issue.title,
          task_id: issue.issue_id, // if you're using task_id convention elsewhere
          isHeader: false,
        });
      }
    });
  });

  // No milestone section
  if (data?.no_milestone_issues?.length) {
    options.push({
      title: "Issues",
      isHeader: true,
      type: "issue",
    });

    data.no_milestone_issues.forEach((issue) => {
      const status = (issue.current_status_name || issue.status_name || "").toUpperCase();
      if (!status.includes("CLOSED")) {
        options.push({
          ...issue,
          title: issue.title,
          task_id: issue.issue_id, // unify selection logic
          isHeader: false,
        });
      }
    });
  }

  return options;
};

export const customIssueFilterOptions = (options, state) => {
  const filtered = filter(
    options.filter((o) => !o.isHeader),
    state
  );

  const result = [];
  let currentHeader = null;

  for (const option of options) {
    if (option.isHeader) {
      currentHeader = option;
    } 
    else if (filtered.includes(option)) {
      if (!result.includes(currentHeader)) {
        result.push(currentHeader);
      }
      result.push(option);
    }
  }

  return result;
};

export const CommonExportComponent = ({
  view_type,
  onApply,
  onClear,
  onCancel,
  isModule,
  isTask,
  to_date,
  from_date,
  project_span,
}) => {
  const { id } = useParams();
  const project_id = localStorage.getItem("project_id");
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  //console.log("login_user in pproject:", login_user);
  const {
    role: login_user_role,
    id: login_user_id,
    name: login_user_name,
  } = login_user;
  const radioRef = useRef();
  const [selectedUserId, setSelectedUserId] = useState(login_user_id);
  const [formatName, setFormatName] = useState("");
  const [selectedProjectId, setSelectedProjectId] = useState(
    isModule ? null : project_id
  );
  // console.log("session_data :", from_date, to_date);

  const [filteredResponse, setFilteredResponse] = useState([]);
  //console.log("useparams id : ", id);
  // const { data: taskNameOptions } =
  //   useFetchGetAllProjectBasedTaskNamesQuery(selectedUser);
  const { data: getAllUsers } = useFetchGetallUserListQuery();
  const { data: UserNameOptions } =
    useFetchGetAllProjectBasedUserNameListQuery(selectedProjectId, {
      skip: !selectedProjectId,
    });
  const allUserList = Array.isArray(getAllUsers)
    ? getAllUsers.map((user) => ({
        id: user.user_id,
        title: user.name,
      }))
    : [];

  const projectUserList = Array.isArray(UserNameOptions)
    ? UserNameOptions.map((user) => ({
        id: user.user_id,
        title: user.name,
      }))
    : [];

  // Conditional user list
  const userNameList = selectedProjectId ? projectUserList : allUserList;

  //console.log("project_based_user_names :", userNameList);
  // const { data: issueNameOptions } =
  //   useFetchGetAllProjectBasedIssueNamesQuery(selectedUser);
  const { data: issueNameOptions } = useFetchuserbasedIssuesQuery(
    { user_id: selectedUserId, project_id: selectedProjectId },
    { skip: !selectedProjectId }
  );
  const { data: taskNameOptions} = useFetchuserbasedTasksQuery(
    { user_id: selectedUserId, project_id: selectedProjectId },
    { skip: !selectedProjectId }
  );
  const { data: user_accessed_project } = useFetchUserAccessedProjectsQuery();
  //console.log("user_accessed_project :", user_accessed_project);

  useEffect(() => {
    const sessionData = sessionStorage.getItem("filtered_timesheets");

    if (sessionData) {
      const parsedData = JSON.parse(sessionData);
      // const formattedData = transformFilteredData(parsedData);
      // //console.log("filtered parse data:", formattedData);
      setFilteredResponse(parsedData); // This will not cause an infinite loop
      // //console.log("Transformed Data:", formattedData);
    } else {
      //console.log("No data found in session storage.");
    }
  }, []); // Empty dependency array ensures this only runs once

  const timesheetViewOptions = useSelector((state) => state.selectOptions?.timesheetViewOptions || {});

  const timesheetViewOptionsArray = Object.entries(timesheetViewOptions).map(
    ([key, value]) => ({
      title: value, // Display value in the dropdown
      value: key, // Key as the unique identifier
    })
  );

  //console.log(
  //   "Transformed timesheetViewOptionsArray:",
  //   timesheetViewOptionsArray
  // );

  // //console.log("userNamesByProjects :", usersInproject);

  const [loading, setLoading] = useState(false);
  const {
    handleSubmit,
    control,
    reset,
    watch,
  } = useForm({
    defaultValues: {
      Users: login_user_role === "EMPLOYEE" ? [login_user_id] : [],
      Taasks: "",
      Issues: "",

      StartDate:
        project_span === "project_span"
          ? null
          : from_date
          ? dayjs(from_date, "YYYY-MM-DD")
          : null,

      EndDate:
        project_span === "project_span"
          ? null
          : to_date
          ? dayjs(to_date, "YYYY-MM-DD")
          : null,

      billingType: "",
      createdBy: "",
      exportData: "default",
      timesheetView: "",
      format: "",
      group_by: "users",
    },
  });
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  const [loadingButton, setLoadingButton] = useState(null);

const handleApply = handleSubmit((data) => {
  const format = data.format;
  const group_by = data.group_by;

  if (format === "excel" && group_by === "users") {
    // Open modal
    setOpen(true);
  } 
  else {
    // Directly call your export function
    onSubmit(data);
  }
});



  const handleClose = () => {
    setChecked(false);
    setOpen(false);
  };

  const handleDownload = () => {
    setLoading(true);
    // simulate a download or API call
    setTimeout(() => {
      setLoading(false);
      setOpen(false);
      alert("Downloaded successfully!"); // replace with your actual download logic
    }, 1500);
  };

  const onSubmit = async (data) => {
    //console.log("owner_data :", data);
    const requestedData = {
      users: data.Users,
      tasks: data.Tasks,
      project_id: isModule ? data.project_id : project_id,
      issues: data.Issues,
      created_by: data.createdBy,
      billing_type: data.billingType,
      start_date: data.StartDate
        ? format(new Date(data.StartDate), "yyyy-MM-dd")
        : null,
      end_date: data.EndDate
        ? format(new Date(data.EndDate), "yyyy-MM-dd")
        : null,
      columns: data.timesheetView,
      export_mode: data.exportData,
      format: data.format,
      filtered_data: filteredResponse,
      view_type: view_type,
      project_span: project_span,
      group_by: data.group_by,
      include_leaves: data.include_leaves ?? false, 
    };
    setLoading(true);
    //console.log("filter_requested_in_export data:", requestedData);

    try {
      const response = await postdatas("timesheet", "export", requestedData);
      //console.log("doc_urls response :", response);

      if (response) {
        const doc_url = response.doc_url;
        //console.log("doc_urls : ", doc_url);

        const formattedDocUrl = doc_url.replace(/\\/g, "/"); // Replace backslashes
        //console.log("Formatted doc_urls:", formattedDocUrl);
        onCancel();
        if (!formattedDocUrl) {
          throw new Error("Document URL not found");
        }

        // Open the file URL directly
        // window.open(formattedDocUrl, "_blank");
        openInNewTab(formattedDocUrl);
        // toast.success("Document downloaded successfully");
      } 
      else {
        throw new Error("The response does not contain a valid doc_url.");
      }

      toast.success("Export successful.");
    } 
    catch (error) {
      console.error("Error filtering tasks:", error.message);
      toast.error(error.message);
    } 
    finally {
      setLoading(false);
    }
  };

  const formattedTaskOptions = formatTaskOptions(taskNameOptions);
  const allIssueOptions = formatIssueOptions(issueNameOptions);
  const handleClear = () => {
    reset(); // Reset the form to default values
    onClear?.(); // Trigger any additional clear action if provided
  };
  const format_name_watch = watch("format");
  //console.log("format_name :", formatName, format_name_watch);

  // Add this function inside your component, above the return()
// const handleDownloadWithLeaves = (includeLeaves) => {
//   // call react-hook-form's handleSubmit but inject extra data before sending
//   return handleSubmit((data) => {
//     onSubmit({ ...data, include_leaves: includeLeaves });
//   });
// };

const handleDownloadWithLeaves = (includeLeaves) => {
  return handleSubmit(async (data) => {
    setLoadingButton(includeLeaves ? "yes" : "no");
    try {
      await onSubmit({ ...data, include_leaves: includeLeaves });
    } 
    finally {
      setLoadingButton(null);
    }
  });
};


  return (
    <div>
      {/* Header Section */}
      <div className="d-flex align-items-center bg-white justify-content-between px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack className=" text-rgba-gray" />
            Export Timelog
          </div>
        </button>
                <div>
          <button
            type="button"
            onClick={handleClear}
            className="R_btn tex-tgba-red clear-filter-btn"
          >
            Clear Filter
          </button>
        </div>
      </div>

      {/* Filter Form */}
      <div className="bg-white px-4 py-3">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            {isModule && (
              <>
                <div className="col-md-12 mb-2">
                  <label htmlFor="project_id" className="form-label">
                    Project name
                    {/* <span className="errorMsg">*</span> */}
                  </label>
                  <Controller
                    name="project_id"
                    control={control}
                    // rules={{ required: "Project field is required" }}
                    render={({
                      field: { onChange, value },
                      formState: { errors },
                    }) => (
                      <>
                        <Autocomplete
                          id="project_id"
                          options={
                            Array.isArray(user_accessed_project)
                              ? user_accessed_project
                              : []
                          }
                          getOptionLabel={(option) => option.title}
                          value={
                            user_accessed_project?.find(
                              (user) => user.project_id === value
                            ) || null
                          }
                          onChange={(event, newValue) => {
                            if (newValue) {
                              if (Array.isArray(newValue)) {
                                toast.error("You can select only one project.");
                              } 
                              else {
                                onChange(newValue.project_id);
                                setSelectedProjectId(newValue.project_id); // Set selected user ID
                              }
                            } else {
                              onChange(null);
                              setSelectedProjectId(null); // Reset selected user ID
                            }
                          }}
                          renderOption={(props, option, { selected }) => (
                            <li
                              {...props}
                              className="d-flex align-items-center mb-2"
                            >
                              <Checkbox
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              <strong>{option?.title}</strong>
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select project"
                            />
                          )}
                        />
                        <span className="errorMsg">
                          {errors?.project_id?.message}
                        </span>
                      </>
                    )}
                  />
                </div>
              </>
            )}

            <>
              <div className="g-3  mb-2 row">
                {/* Row 1 */}
                <div className="col-md-12 \">
                  <label htmlFor="Users" className="form-label">
                    Users
                    {/* <span className="errorMsg">*</span> */}
                  </label>
                  {login_user_role === "EMPLOYEE" ? (
                    <FormControl fullWidth>
                      <Select value={login_user_id}>
                        <MenuItem value={login_user_id}>
                          {login_user_name}
                        </MenuItem>
                      </Select>
                    </FormControl>
                  ) : (
                    <Controller
                      name="Users"
                      control={control}
                      render={({ field: { onChange, value } }) => {
                        const ALL_OPTION = { id: "all", title: "Select All" };

                        const allSelected =
                          Array.isArray(value) &&
                          userNameList.length > 0 &&
                          value.length === userNameList.length &&
                          userNameList.every((user) => value.includes(user.id));

                        const optionsWithAll = [ALL_OPTION, ...userNameList];

                        const selectedValues =
                          Array.isArray(value) && value.length === 0
                            ? []
                            : userNameList.filter((user) =>
                                value?.includes(user.id)
                              );

                        const handleUserChange = (event, newValue) => {
                          const isAllSelected = newValue.some(
                            (val) => val.id === "all"
                          );

                          if (isAllSelected) {
                            // "Select All" was clicked
                            const isCurrentlyAllSelected =
                              value.length === userNameList.length &&
                              userNameList.every((user) =>
                                value.includes(user.id)
                              );

                            if (isCurrentlyAllSelected) {
                              // User is unchecking "Select All"
                              onChange([]);
                              setSelectedUserId([]);
                            } else {
                              // User is selecting "Select All"
                              const allIds = userNameList.map(
                                (user) => user.id
                              );
                              onChange(allIds);
                              setSelectedUserId(allIds);
                            }
                          } else {
                            // "Select All" is not in newValue, treat as normal selection
                            const selectedIds = newValue.map((val) => val.id);
                            onChange(selectedIds);
                            setSelectedUserId(selectedIds);
                          }
                        };

                        return (
                          <Autocomplete
                            multiple
                            id="Users"
                            options={optionsWithAll}
                            disableCloseOnSelect
                            getOptionLabel={(option) =>
                              option.id === "all" ? "Select All" : option.title
                            }
                            value={selectedValues}
                            onChange={handleUserChange}
                            renderOption={(props, option, { selected }) => (
                              <li
                                {...props}
                                className="d-flex align-items-center mb-2"
                              >
                                <Checkbox
                                  style={{ marginRight: 8 }}
                                  checked={
                                    option.id === "all" ? allSelected : selected
                                  }
                                />
                                <strong>{option.title}</strong>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField {...params} placeholder="Users" />
                            )}
                            ListboxProps={{
                              style: {
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "8px",
                                paddingLeft: "0",
                              },
                            }}
                          />
                        );
                      }}
                    />
                  )}
                  {/* <span className="errorMsg">{errors?.Users?.message}</span> */}
                </div>

                <div className="col-md-12  mb-2">
                  <label htmlFor="Tasks" className="form-label">
                    Tasks
                  </label>
                  <Controller
                    name="Tasks"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <Autocomplete
                        multiple
                        id="Tasks"
                        options={formattedTaskOptions}
                        getOptionLabel={(option) => option.title}
                        disableCloseOnSelect
                        filterOptions={customFilterOptions}
                        isOptionEqualToValue={(option, value) =>
                          option.task_id === value.task_id
                        }
                        value={
                          Array.isArray(value)
                            ? formattedTaskOptions.filter((opt) =>
                                value.includes(opt.task_id)
                              )
                            : []
                        }
                        onChange={(event, newValue) => {
                          const selectedIds = newValue.map(
                            (task) => task.task_id
                          );
                          onChange(selectedIds); // Send only IDs to parent
                        }}
                        renderOption={(props, option, { selected }) =>
                          option.isHeader ? (
                            <li
                              {...props}
                              style={{
                                fontWeight: "bold",
                                opacity: 0.8,
                                pointerEvents: "none",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                gridColumn: "1 / -1", // 🔥 Makes header span both columns
                              }}
                            >
                              {option.type === "milestone" ? (
                                <img
                                  src={milestoneImage}
                                  alt="milestone"
                                  width={20}
                                  height={20}
                                />
                              ) : option.type === "task_list" ? (
                                <img
                                  src={taskImage}
                                  alt="task list"
                                  width={16}
                                />
                              ) : option.type === "issue" ? (
                                <img src={issueImage} alt="issue" width={16} />
                              ) : null}
                              {option.title}
                            </li>
                          ) : (
                            <li
                              {...props}
                              className="d-flex align-items-center mb-2"
                            >
                              <Checkbox
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              <strong>{option.title}</strong>
                            </li>
                          )
                        }
                        renderInput={(params) => (
                          <TextField {...params} placeholder="Select task" />
                        )}
                        ListboxProps={{
                          style: {
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "8px",
                            paddingLeft: "0",
                          },
                        }}
                      />
                    )}
                  />
                </div>

                <div className="col-md-12 ">
                  <label htmlFor="Issues" className="form-label">
                    Issues
                  </label>
                  <Controller
                    name="Issues"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <Autocomplete
                        multiple
                        id="Issues"
                        options={allIssueOptions}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.title}
                        filterOptions={customIssueFilterOptions}
                        isOptionEqualToValue={(option, value) =>
                          option.issue_id === value.issue_id
                        }
                        value={
                          Array.isArray(value)
                            ? allIssueOptions.filter((opt) =>
                                value.includes(opt.issue_id)
                              )
                            : []
                        }
                        onChange={(event, newValue) => {
                          const selectedIds = newValue.map(
                            (issue) => issue.issue_id
                          );
                          onChange(selectedIds);
                        }}
                        renderOption={(props, option, { selected }) =>
                          option.isHeader ? (
                            <li
                              {...props}
                              style={{
                                fontWeight: "bold",
                                opacity: 0.8,
                                pointerEvents: "none",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                gridColumn: "1 / -1", // 🔥 Full width header
                              }}
                            >
                              {option.type === "milestone" ? (
                                <img
                                  src={milestoneImage}
                                  alt="milestone"
                                  width={20}
                                  height={20}
                                />
                              ) : (
                                <img src={issueImage} alt="issue" width={16} />
                              )}
                              {option.title}
                            </li>
                          ) : (
                            <li
                              {...props}
                              className="d-flex align-items-center mb-2"
                            >
                              <Checkbox
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              <strong>{option.title}</strong>
                            </li>
                          )
                        }
                        renderInput={(params) => (
                          <TextField {...params} placeholder="Select issue" />
                        )}
                        ListboxProps={{
                          style: {
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "8px",
                            paddingLeft: "0",
                          },
                        }}
                      />
                    )}
                  />
                </div>
                {/* Row 2 */}
                <div className="col-md-6">
                  <label htmlFor="StartDate">Start date</label>
                  <div className=" d-flex  flex-column w-100 ">
                    <Controller
                      name="StartDate"
                      control={control}
                      render={({ field }) => (
                        <DatePicker
                          {...field}
                          format="DD/MM/YYYY"
                          onChange={(date) => field.onChange(date)}
                          renderInput={(params) => (
                            <TextField {...params} className="form-control" />
                          )}
                        />
                      )}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <label htmlFor="EndDate">End date</label>
                  <div className=" d-flex  flex-column w-100 ">
                    <Controller
                      control={control}
                      name="EndDate"
                      render={({ field }) => (
                        <DatePicker
                          {...field}
                          onChange={(date) => field.onChange(date)}
                          format="DD/MM/YYYY"
                          renderInput={(params) => (
                            <TextField {...params} className="form-control" />
                          )}
                        />
                      )}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="form-label">Billing Type</label>
                  <Controller
                    name="billingType"
                    control={control}
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              selected
                            ) : (
                              <span className="lightText">Select type</span>
                            )
                          }
                        >
                          <MenuItem value="BILLABLE">Billable</MenuItem>
                          <MenuItem value="NON-BILLABLE">Non-Billable</MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>

                {/* Row 3 */}
                {login_user_role !== "EMPLOYEE" && (
                  <div className="col-md-6">
                    <label className="form-label">Created By</label>
                    <Controller
                      name="createdBy"
                      control={control}
                      render={({ field }) => (
                        <FormControl fullWidth>
                          <Select
                            {...field}
                            displayEmpty
                            renderValue={(selected) =>
                              selected ? (
                                userNameList?.find(
                                  (user) => user.user_id === selected
                                )?.title
                              ) : (
                                <span className="lightText">Select user</span>
                              )
                            }
                          >
                            {userNameList?.map((user, index) => (
                              <MenuItem key={index} value={user.user_id}>
                                {user.title}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    />
                  </div>
                )}

                {/* Row 3 */}

                <div className="col-md-6">
                  <label className="form-label">
                    Format <span className="errorMsg">*</span>
                  </label>
                  <Controller
                    name="format"
                    rules={{ required: "Format field is required" }}
                    control={control}
                    render={({
                      field: { ref, onChange, value },
                      fieldState: { error },
                    }) => (
                      <FormControl fullWidth>
                        <Select
                          // {...field}
                          inputRef={ref}
                          onChange={(e) => {
                            onChange(e);
                            setFormatName(e.target.value);
                          }}
                          value={value}
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              selected
                            ) : (
                              <span className="lightText">Format</span>
                            )
                          }
                        >
                          <MenuItem value="excel">excel</MenuItem>
                          <MenuItem value="pdf">pdf</MenuItem>
                        </Select>
                        {error && (
                          <span className="errorMsg">{error.message}</span>
                        )}
                      </FormControl>
                    )}
                  />
                </div>
              </div>

              {format_name_watch === "excel" && (
                <div className="col-md-12 mt-3">
                  <label htmlFor="timesheetView" className="form-label">
                    Timesheet View
                    {/* <span className="errorMsg">*</span> */}
                  </label>

                  <Controller
                    name="timesheetView"
                    control={control}
                    // rules={{ required: "Export column field is required" }}
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <>
                        <Autocomplete
                          multiple
                          id="timesheetView"
                          options={[
                            { value: "all", title: "Select All" },
                            ...timesheetViewOptionsArray,
                          ]}
                          disableCloseOnSelect
                          getOptionLabel={(option) =>
                            option.value === "all"
                              ? "Select All"
                              : option.title || ""
                          }
                          value={
                            Array.isArray(value)
                              ? value.includes("all")
                                ? [
                                    { value: "all", title: "Select All" },
                                    ...timesheetViewOptionsArray,
                                  ]
                                : timesheetViewOptionsArray.filter((item) =>
                                    value.includes(item.value)
                                  )
                              : []
                          }
                          onChange={(event, newValue) => {
                            const allOptionValues =
                              timesheetViewOptionsArray.map(
                                (item) => item.value
                              );
                            const newValueSet = new Set(
                              newValue.map((item) => item.value)
                            );
                            const allSelected = allOptionValues.every((val) =>
                              newValueSet.has(val)
                            );

                            if (newValue.some((item) => item.value === "all")) {
                              if (allSelected) {
                                // Uncheck all
                                onChange([]);
                              } 
                              else {
                                // Select all
                                onChange(allOptionValues);
                              }
                            } else {
                              const selectedValues = newValue.map(
                                (item) => item.value
                              );
                              onChange(selectedValues);
                            }
                          }}
                          renderOption={(props, option, { selected }) => (
                            <li
                              {...props}
                              className="d-flex align-items-center mb-2"
                            >
                              <Checkbox
                                style={{ marginRight: 8 }}
                                checked={
                                  option.value === "all"
                                    ? Array.isArray(value) &&
                                      timesheetViewOptionsArray.length > 0 &&
                                      value.length ===
                                        timesheetViewOptionsArray.length
                                    : selected
                                }
                              />
                              <strong>{option.title}</strong>
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Timesheet View"
                            />
                          )}
                          ListboxProps={{
                            style: {
                              display: "grid",
                              gridTemplateColumns: "1fr 1fr",
                              gap: "8px",
                              paddingLeft: "0",
                            },
                          }}
                        />
                        {error && (
                          <span className="errorMsg">{error.message}</span>
                        )}
                      </>
                    )}
                  />
                </div>
              )}

              <div className="row mt-3 ">
                <div className="col-md-12">
                  <label htmlFor="">
                    Group Type
                    <span className="errorMsg">*</span>
                  </label>
                  <Controller
                    name="group_by"
                    control={control}
                    rules={{ required: "Group Type field is required" }}
                    render={({ field, fieldState: { error } }) => {
                      if (error && radioRef.current) {
                        radioRef.current.focus();
                      }

                      return (
                        <div>
                          <RadioGroup row {...field}>
                            <FormControlLabel
                              value="users"
                              control={<Radio />}
                              label="Group By Users"
                            />
                            <FormControlLabel
                              value="hours"
                              control={<Radio />}
                              label="Group By Hours"
                            />
                            {!isTask && (
                              <FormControlLabel
                                value="projects"
                                control={<Radio />}
                                label="Group By Projects"
                                ref={radioRef}
                              />
                            )}
                          </RadioGroup>
                          {error && <p className="errorMsg">{error.message}</p>}
                        </div>
                      );
                    }}
                  />
                </div>
              </div>

              <div className="row mt-3 paddingBtn">
                <div className="col-md-12">
                  <label htmlFor="">
                    Filter Type
                    <span className="errorMsg">*</span>
                  </label>
                  <Controller
                    name="exportData"
                    control={control}
                    rules={{ required: "Export Type field is required" }}
                    render={({ field, fieldState: { error } }) => {
                      if (error && radioRef.current) {
                        radioRef.current.focus();
                      }
                      return (
                        <div>
                          <RadioGroup row {...field}>
                            <FormControlLabel
                              value="default"
                              control={<Radio />}
                              label="Export default data"
                            />
                            {!isTask && (
                              <FormControlLabel
                                value="current_filter"
                                control={<Radio />}
                                label="Export along with the current filter section"
                                ref={radioRef}
                              />
                            )}
                          </RadioGroup>
                          {error && <p className="errorMsg">{error.message}</p>}
                        </div>
                      );
                    }}
                  />
                </div>
              </div>
            </>

            {/* Footer Buttons */}
            <div className="d-flex bg-white position-absolute w-100 bottom-0 mt-5 py-3">
              <button
                type="button"
                className="add_btn me-3"
                disabled={loading}
                onClick={handleApply}
              >
                  {loading ? <BtnLoader /> : "Apply"}
              </button>

              <button
                type="button"
                className="cancel_btn"
                disabled={loading}
                onClick={onCancel}
              >
                Cancel
              </button>
            </div>
          </form>

              <Modal open={open} onClose={handleClose}>
                <Box
                  sx={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    bgcolor: "var(--cell-bg-color, #fff)",
                    color: "var(--text-color, #000)",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: "8px",
                    textAlign: "center",
                    minWidth: 350,
                  }}
                >
                  {/* Close Icon */}
                  <IconButton
                    onClick={handleClose}
                    sx={{
                      position: 'absolute',
                      top: 8,
                      right: 8,
                      color: 'var(--text-color, #000)',
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
              
                  <Typography variant="h6" gutterBottom>
                    Do you want to download including leaves?
                  </Typography>
              
                  <div className="d-flex justify-content-center mt-4 gap-3">
                     <button
                      className="me-3 add_btn"
                      disabled={loadingButton !== null}
                      onClick={handleDownloadWithLeaves(true)}
                    >
                      {loadingButton === "yes" ? <BtnLoader /> : "Yes"}
                    </button>
              
                    <button
                      className="cancel_btn"
                      disabled={loadingButton !== null}
                      onClick={handleDownloadWithLeaves(false)}
                    >
                      {loadingButton === "no" ? <BtnLoader /> : "No"}
                    </button>
                  </div>
                </Box>
              </Modal>
        </LocalizationProvider>
      </div>
    </div>
  );
};


export const CommonExportFormat = ({
  view_type,
  onApply,
  onClear,
  onCancel,
  isModule,
  isTask,
  to_date,
  from_date,
  project_span,
}) => {
  const { id } = useParams();
  const project_id = localStorage.getItem("project_id");
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  //console.log("login_user in pproject:", login_user);
  const {
    role: login_user_role,
    id: login_user_id,
    name: login_user_name,
  } = login_user;
  const radioRef = useRef();
  const [selectedUserId, setSelectedUserId] = useState(login_user_id);
  // const [formatName, setFormatName] = useState("");
  const [selectedProjectId, setSelectedProjectId] = useState(
    isModule ? null : project_id
  );
  // console.log("session_data :", from_date, to_date);

  const [filteredResponse, setFilteredResponse] = useState([]);
  //console.log("useparams id : ", id);
  // const { data: taskNameOptions } =
  //   useFetchGetAllProjectBasedTaskNamesQuery(selectedUser);
  const { data: getAllUsers } = useFetchGetallUserListQuery();

  const { data: UserNameOptions } = useFetchGetAllProjectBasedUserNameListQuery(
    selectedProjectId,
    // { skip: selectedProjectId }
      { skip: !selectedProjectId }
  );
  const allUserList = Array.isArray(getAllUsers)
    ? getAllUsers.map((user) => ({
        id: user.user_id,
        title: user.name,
      }))
    : [];

  const projectUserList = Array.isArray(UserNameOptions)
    ? UserNameOptions.map((user) => ({
        id: user.user_id,
        title: user.name,
      }))
    : [];

  // Conditional user list
  const userNameList = selectedProjectId ? projectUserList : allUserList;

  //console.log("project_based_user_names :", userNameList);
  // const { data: issueNameOptions } =
  //   useFetchGetAllProjectBasedIssueNamesQuery(selectedUser);
  const { data: issueNameOptions } = useFetchuserbasedIssuesQuery(
    { user_id: selectedUserId, project_id: selectedProjectId },
    { skip: !selectedProjectId }
  );
  const { data: taskNameOptions } = useFetchuserbasedTasksQuery(
    { user_id: selectedUserId, project_id: selectedProjectId },
    { skip: !selectedProjectId }
  );
  const { data: user_accessed_project } = useFetchUserAccessedProjectsQuery();
  //console.log("user_accessed_project :", user_accessed_project);

  useEffect(() => {
    const sessionData = sessionStorage.getItem("filtered_timesheets");

    if (sessionData) {
      const parsedData = JSON.parse(sessionData);
      // const formattedData = transformFilteredData(parsedData);
      // //console.log("filtered parse data:", formattedData);
      setFilteredResponse(parsedData); // This will not cause an infinite loop
      // //console.log("Transformed Data:", formattedData);
    } else {
      //console.log("No data found in session storage.");
    }
  }, []); // Empty dependency array ensures this only runs once

  const timesheetViewOptions = useSelector(
    (state) => state.selectOptions?.timesheetViewOptions || {}
  );

  const timesheetViewOptionsArray = Object.entries(timesheetViewOptions).map(
    ([key, value]) => ({
      title: value, // Display value in the dropdown
      value: key, // Key as the unique identifier
    })
  );

  //console.log(
  //   "Transformed timesheetViewOptionsArray:",
  //   timesheetViewOptionsArray
  // );

  // //console.log("userNamesByProjects :", usersInproject);

  const [loading, setLoading] = useState(false);
  const {
    handleSubmit,
    control,
    reset,
    watch,
  } = useForm({
    defaultValues: {
      // Users: login_user_role === "EMPLOYEE" ? [login_user_id] : [],
      // Taasks: "",
      // Issues: "",
      Users: login_user_role === "EMPLOYEE" ? [login_user_id] : [],
      Tasks: [],
      Issues: [],

      // StartDate:
        // project_span === "project_span"
        //   ? null
        //   : from_date
        //   ? dayjs(from_date, "YYYY-MM-DD")
        //   :
        // null,
          StartDate: null,

      // EndDate:
        // project_span === "project_span"
        //   ? null
        //   : to_date
        //   ? dayjs(to_date, "YYYY-MM-DD")
        // :
        // null,
        EndDate: null,
        
      project_id: null,
      type: "totalHours",
      // billingType: "",
      // createdBy: "",
      // exportData: "",
      // timesheetView: "",
      // format: "",
    },
  });

  const onSubmit = async (data) => {
    //console.log("owner_data :", data);
    const requestedData = {
      // users: data.Users,
      // tasks: data.Tasks,
      users: data.Users,
      tasks: data.Tasks,
      projectId: isModule ? data.project_id : project_id,
      // issues: data.Issues,
      // created_by: data.createdBy,
      // billing_type: data.billingType,
      issues: data.Issues,
      
      fromDate: data.StartDate
        ? format(new Date(data.StartDate), "yyyy-MM-dd")
        : null,
      toDate: data.EndDate
        ? format(new Date(data.EndDate), "yyyy-MM-dd")
        : null,
      type: data.type,
      // columns: data.timesheetView,
      // export_mode: data.exportData,
      // format: data.format,
      // filtered_data: filteredResponse,
      // view_type: view_type,
      // project_span: project_span,
    };
    setLoading(true);
    //console.log("filter_requested_in_export data:", requestedData);

    try {
      const response = await createEntity("exportTimesheet", requestedData);
      //console.log("doc_urls response :", response);
      if (response) {
        const doc_url = response.url;
        const link = document.createElement("a");
        link.href = doc_url;
        link.download = "";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        onCancel();
        toast.success(response.message);
      }

      // toast.success("Export successful.");
    } 
    catch (error) {
      // console.error("Error filtering tasks:", error.message);
      toast.error(error.message);
    } 
    finally {
      setLoading(false);
    }
  };

  const formattedTaskOptions = formatTaskOptions(taskNameOptions);
  const allIssueOptions = formatIssueOptions(issueNameOptions);
  const handleClear = () => {
    reset(); // Reset the form to default values
    onClear?.(); // Trigger any additional clear action if provided
  };
  const format_name_watch = watch("format");
  //console.log("format_name :", formatName, format_name_watch);

  return (
    <div>
      {/* Header Section */}
      <div className="d-flex align-items-center bg-white justify-content-between px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack className=" text-rgba-gray" />
            Export Timelog
          </div>
        </button>

        <div>
          <button
            type="button"
            onClick={handleClear}
            className="R_btn tex-tgba-red clear-filter-btn"
          >
            Clear filter
          </button>
        </div>
      </div>

      {/* Filter Form */}
      <div className="bg-white px-4 py-3">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            {isModule && (
              <>
                <div className="col-md-12 mb-2">
                  <label htmlFor="project_id" className="form-label">
                    Project name
                    <span className="errorMsg">*</span>
                  </label>
                  <Controller
                    name="project_id"
                    control={control}
                    rules={{ required: "Project field is required" }}
                    render={({
                      field: { onChange, value },
                      formState: { errors },
                    }) => (
                      <>
                        <Autocomplete
                          id="project_id"
                          options={
                            Array.isArray(user_accessed_project)
                              ? user_accessed_project
                              : []
                          }
                          getOptionLabel={(option) => option.title}
                          value={
                            user_accessed_project?.find(
                              (user) => user.project_id === value
                            ) || null
                          }
                          onChange={(event, newValue) => {
                            if (newValue) {
                              if (Array.isArray(newValue)) {
                                toast.error("You can select only one project.");
                              } else {
                                onChange(newValue.project_id);
                                setSelectedProjectId(newValue.project_id); // Set selected user ID
                              }
                            } else {
                              onChange(null);
                              setSelectedProjectId(null); // Reset selected user ID
                            }
                          }}
                          renderOption={(props, option, { selected }) => (
                            <li
                              {...props}
                              className="d-flex align-items-center mb-2"
                            >
                              <Checkbox
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              <strong>{option?.title}</strong>
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select project"
                            />
                          )}
                        />
                        <span className="errorMsg">
                          {errors?.project_id?.message}
                        </span>
                      </>
                    )}
                  />
                </div>
              </>
            )}

            <>
            {/* Added export All option in implemtn tasks/mileston task and isserus, users like epxort option => in timehseet */}
              <div className="g-3  mb-2 row">
                <div className="col-md-12 mb-2">
                  <label htmlFor="Users" className="form-label">
                    Users
                  </label>
                  {login_user_role === "EMPLOYEE" ? (
                    <FormControl fullWidth>
                      <Select value={login_user_id}>
                        <MenuItem value={login_user_id}>
                          {login_user_name}
                        </MenuItem>
                      </Select>
                    </FormControl>
                  ) : (
                    <Controller
                      name="Users"
                      control={control}
                      render={({ field: { onChange, value } }) => {
                        const ALL_OPTION = { id: "all", title: "Select All" };
                        const allSelected =
                          Array.isArray(value) &&
                          userNameList.length > 0 &&
                          value.length === userNameList.length &&
                          userNameList.every((user) => value.includes(user.id));
                        const optionsWithAll = [ALL_OPTION, ...userNameList];
                        const selectedValues =
                          Array.isArray(value) && value.length === 0
                            ? []
                            : userNameList.filter((user) =>
                                value?.includes(user.id)
                              );

                        const handleUserChange = (event, newValue) => {
                          const isAllSelected = newValue.some(
                            (val) => val.id === "all"
                          );
                          if (isAllSelected) {
                            const isCurrentlyAllSelected =
                              value.length === userNameList.length &&
                              userNameList.every((user) =>
                                value.includes(user.id)
                              );
                            if (isCurrentlyAllSelected) {
                              onChange([]);
                              setSelectedUserId([]);
                            } else {
                              const allIds = userNameList.map(
                                (user) => user.id
                              );
                              onChange(allIds);
                              setSelectedUserId(allIds);
                            }
                          } else {
                            const selectedIds = newValue.map((val) => val.id);
                            onChange(selectedIds);
                            setSelectedUserId(selectedIds);
                          }
                        };

                        return (
                          <Autocomplete
                            multiple
                            id="Users"
                            options={optionsWithAll}
                            disableCloseOnSelect
                            getOptionLabel={(option) =>
                              option.id === "all" ? "Select All" : option.title
                            }
                            value={selectedValues}
                            onChange={handleUserChange}
                            renderOption={(props, option, { selected }) => (
                              <li
                                {...props}
                                className="d-flex align-items-center mb-2"
                              >
                                <Checkbox
                                  style={{ marginRight: 8 }}
                                  checked={
                                    option.id === "all" ? allSelected : selected
                                  }
                                />
                                <strong>{option.title}</strong>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField {...params} placeholder="Users" />
                            )}
                            ListboxProps={{
                              style: {
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "8px",
                                paddingLeft: "0",
                              },
                            }}
                          />
                        );
                      }}
                    />
                  )}
                </div>

                <div className="col-md-12 mb-2">
                  <label htmlFor="Tasks" className="form-label">
                    Tasks
                  </label>
                  <Controller
                    name="Tasks"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <Autocomplete
                        multiple
                        id="Tasks"
                        options={formattedTaskOptions}
                        getOptionLabel={(option) => option.title}
                        disableCloseOnSelect
                        filterOptions={customFilterOptions}
                        isOptionEqualToValue={(option, value) =>
                          option.task_id === value.task_id
                        }
                        value={
                          Array.isArray(value)
                            ? formattedTaskOptions.filter((opt) =>
                                value.includes(opt.task_id)
                              )
                            : []
                        }
                        onChange={(event, newValue) => {
                          const selectedIds = newValue.map(
                            (task) => task.task_id
                          );
                          onChange(selectedIds);
                        }}
                        renderOption={(props, option, { selected }) =>
                          option.isHeader ? (
                            <li
                              {...props}
                              style={{
                                fontWeight: "bold",
                                opacity: 0.8,
                                pointerEvents: "none",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                gridColumn: "1 / -1",
                              }}
                            >
                              {option.type === "milestone" ? (
                                <img
                                  src={milestoneImage}
                                  alt="milestone"
                                  width={20}
                                  height={20}
                                />
                              ) : option.type === "task_list" ? (
                                <img
                                  src={taskImage}
                                  alt="task list"
                                  width={16}
                                />
                              ) : option.type === "issue" ? (
                                <img src={issueImage} alt="issue" width={16} />
                              ) : null}
                              {option.title}
                            </li>
                          ) : (
                            <li
                              {...props}
                              className="d-flex align-items-center mb-2"
                            >
                              <Checkbox
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              <strong>{option.title}</strong>
                            </li>
                          )
                        }
                        renderInput={(params) => (
                          <TextField {...params} placeholder="Select task" />
                        )}
                        ListboxProps={{
                          style: {
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "8px",
                            paddingLeft: "0",
                          },
                        }}
                      />
                    )}
                  />
                </div>

                <div className="col-md-12 mb-2">
                  <label htmlFor="Issues" className="form-label">
                    Issues
                  </label>
                  <Controller
                    name="Issues"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <Autocomplete
                        multiple
                        id="Issues"
                        options={allIssueOptions}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.title}
                        filterOptions={customIssueFilterOptions}
                        isOptionEqualToValue={(option, value) =>
                          option.issue_id === value.issue_id
                        }
                        value={
                          Array.isArray(value)
                            ? allIssueOptions.filter((opt) =>
                                value.includes(opt.issue_id)
                              )
                            : []
                        }
                        onChange={(event, newValue) => {
                          const selectedIds = newValue.map(
                            (issue) => issue.issue_id
                          );
                          onChange(selectedIds);
                        }}
                        renderOption={(props, option, { selected }) =>
                          option.isHeader ? (
                            <li
                              {...props}
                              style={{
                                fontWeight: "bold",
                                opacity: 0.8,
                                pointerEvents: "none",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                gridColumn: "1 / -1",
                              }}
                            >
                              {option.type === "milestone" ? (
                                <img
                                  src={milestoneImage}
                                  alt="milestone"
                                  width={20}
                                  height={20}
                                />
                              ) : (
                                <img src={issueImage} alt="issue" width={16} />
                              )}
                              {option.title}
                            </li>
                          ) : (
                            <li
                              {...props}
                              className="d-flex align-items-center mb-2"
                            >
                              <Checkbox
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              <strong>{option.title}</strong>
                            </li>
                          )
                        }
                        renderInput={(params) => (
                          <TextField {...params} placeholder="Select issue" />
                        )}
                        ListboxProps={{
                          style: {
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "8px",
                            paddingLeft: "0",
                          },
                        }}
                      />
                    )}
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="StartDate">
                    From date <span className="errorMsg">*</span>
                  </label>
                  <div className=" d-flex  flex-column w-100 ">
                    <Controller
                      name="StartDate"
                      control={control}
                      render={({ field }) => (
                        <DatePicker
                          {...field}
                          format="DD/MM/YYYY"
                          onChange={(date) => field.onChange(date)}
                          renderInput={(params) => (
                            <TextField {...params} className="form-control" />
                          )}
                        />
                      )}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <label htmlFor="EndDate">
                    To date <span className="errorMsg">*</span>
                  </label>
                  <div className=" d-flex  flex-column w-100 ">
                    <Controller
                      control={control}
                      name="EndDate"
                      render={({ field }) => (
                        <DatePicker
                          {...field}
                          onChange={(date) => field.onChange(date)}
                          format="DD/MM/YYYY"
                          renderInput={(params) => (
                            <TextField {...params} className="form-control" />
                          )}
                        />
                      )}
                    />
                  </div>
                </div>

                <div className="row mt-3 ">
                  <div className="col-md-12">
                    <label htmlFor="">
                      Type
                      <span className="errorMsg">*</span>
                    </label>
                    <Controller
                      name="type"
                      control={control}
                      defaultValue="totalHours"
                      rules={{ required: "Type field is required" }}
                      render={({ field, fieldState: { error } }) => {
                        if (error && radioRef.current) {
                          radioRef.current.focus();
                        }

                        return (
                          <div>
                            <RadioGroup row {...field}>
                              <FormControlLabel
                                value="totalHours"
                                control={<Radio />}
                                label="Total hours"
                              />
                              {/* {!isTask && ( */}
                              <FormControlLabel
                                value="individualHours"
                                control={<Radio />}
                                label="Individual hours"
                                ref={radioRef}
                              />
                              {/* )} */}
                            </RadioGroup>
                            {error && (
                              <p className="errorMsg">{error.message}</p>
                            )}
                          </div>
                        );
                      }}
                    />
                  </div>
                </div>
              </div>
            </>
            
            {/* Footer Buttons */}
            <div className="d-flex bg-white position-absolute w-100 bottom-0 mt-5 py-3">
              <button type="submit" className="add_btn me-3 " disabled={loading}>
                {loading ? (
                  <>
                    <BtnLoader />
                  </>
                ) : (
                  "Apply"
                )}
              </button>
              <button
                type="button"
                className="cancel_btn"
                disabled={loading}
                onClick={onCancel}
              >
                Cancel
              </button>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};
